import moment from "moment";
import "moment-timezone";
import React, { Component } from "react";
import "react-block-ui/style.css";
import { Nav, NavItem } from "react-bootstrap";
import Datetime from "react-datetime";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import LoadingIndicator from "../Components/LoadingIndicator/LoadingIndicator";
import Flags from "../Deals/Flags";
import SRFlags from "../SeminarRegistrations/Flags";
import TCSFlags from "../TCS/Flags";
import ReportsService from "../utils/ReportsService";

const Stat = props => {
  const { number, text, percentage, alert, warning, show_number } = props;
  let cname = "panel status panel-info";
  if (alert) cname = cname + " panel-danger";
  if (warning) cname = cname + " panel-warning";

  let heading_class = show_number
    ? "panel-heading"
    : "panel-heading panel-success-heading";
  const number_label = show_number ? `${number || 0}` : "";
  const percentage_label = percentage !== undefined ? `(${percentage}%)` : "";

  return (
    <div className="status-card" style={{ width: 225 }}>
      <div className={cname}>
        <div className={heading_class}>
          <h1 className="panel-title text-center">
            {number_label} {percentage_label}
          </h1>
        </div>
        <div className="panel-body text-center">
          <strong>{text}</strong>
        </div>
      </div>
    </div>
  );
};

const UserSalesStatsTable = ({ users }) => {
  const totalSold = users.reduce((sum, u) => sum + u.sales, 0);
  const totalCancelled = users.reduce((sum, u) => sum + (u.cancelled || 0), 0);
  const totalPresented = users.reduce((sum, u) => sum + u.presented, 0);

  const salesRate =
    totalPresented > 0
      ? (((totalSold - totalCancelled) * 100) / totalPresented).toFixed(2)
      : "0.00";

  return (
    <div>
      <div>
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th scope="col">Rep</th>
              <th scope="col">Sales</th>
              <th scope="col">Presented</th>
              <th scope="col">Cancelled Sale</th>
              <th scope="col">Sales Conversion</th>
            </tr>
          </thead>
          <tbody>
            {users.map(user => (
              <tr key={user.email}>
                <td>{user.name}</td>
                <td>{user.sales}</td>
                <td>{user.presented}</td>
                <td>{user.cancelled || 0}</td>
                <td>{user.conversion_rate} %</td>
              </tr>
            ))}
            <tr className="table-secondary">
              <td>
                <strong>Totals</strong>
              </td>
              <td>{totalSold}</td>
              <td>{totalPresented}</td>
              <td>{totalCancelled}</td>
              <td>{salesRate}% avg sales conversion</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

const UserPresentedStatsTable = ({ users }) => {
  const totalPresented = users.reduce((sum, u) => sum + u.presented, 0);
  const totalConfirmed = users.reduce((sum, u) => sum + u.confirmed, 0);

  const presRate =
    totalConfirmed > 0
      ? ((totalPresented * 100) / totalConfirmed).toFixed(2)
      : "0.00";

  return (
    <div>
      <div>
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th scope="col">Rep</th>
              <th scope="col">Presented</th>
              <th scope="col">Confirmed</th>
              <th scope="col">Pres Conversion</th>
            </tr>
          </thead>
          <tbody>
            {users.map(user => (
              <tr key={user.email}>
                <td>{user.name}</td>
                <td>{user.presented}</td>
                <td>{user.confirmed}</td>
                <td>{user.presentation_rate} %</td>
              </tr>
            ))}
            <tr className="table-secondary">
              <td>
                <strong>Totals</strong>
              </td>
              <td>{totalPresented}</td>
              <td>{totalConfirmed}</td>
              <td>{presRate}% avg pres conversion</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

const DealTable = props => (
  <table className="table table-bordered table-zebra">
    <thead>
      <tr>
        <th>Deal</th>
        <th>Contact</th>
        <th>TCS Assigned</th>
        <th>Status</th>
        <th>Flags</th>
        <th>TCS Date</th>
        <th>Parents in house</th>
        <th>Parents attending</th>
      </tr>
    </thead>
    <tbody>
      {props.deals.map(deal => (
        <tr key={deal.id}>
          <td>
            <Link
              to={`/m1/deals/${deal.id}`}
              style={{
                whiteSpace: "nowrap"
              }}
            >
              Deal #{deal.id}
            </Link>
          </td>
          <td>
            <Link to={`/m1/contacts/${deal.contact_id}`}>
              {deal.contact_email}
            </Link>
          </td>
          <td>{deal.tcs_assigned_to && <div>{deal.tcs_assigned_to}</div>}</td>
          <td>
            <div>{deal.reasons[props.tab]}</div>
            {deal.descriptions[props.tab] && (
              <div>
                <small>{deal.descriptions[props.tab]}</small>
              </div>
            )}
          </td>
          <td>
            <SRFlags deal={deal} prefix="Registration: " />
            <TCSFlags deal={deal} prefix="TCS: " />
            <Flags deal={deal} prefix="Deal: " />
          </td>
          <td>
            <Moment format="MMM Do YYYY h:mm a">{deal.tcs_at}</Moment>
          </td>
          <td>
            {deal.tcs_parents_in_household && (
              <div>{deal.tcs_parents_in_household}</div>
            )}
          </td>
          <td>
            {deal.tcs_parents_attending_tcs && (
              <div>{deal.tcs_parents_attending_tcs}</div>
            )}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

class ReportingSalesPersonResults extends Component {
  constructor(props) {
    super(props);
    const defaultFilter = {
      completed: "true",
      date_field: "created_at",
      start_date: moment()
        .tz("Australia/Sydney")
        .subtract(1, "day")
        .format("DD MMM YYYY"),
      end_date: moment()
        .tz("Australia/Sydney")
        .subtract(1, "day")
        .format("DD MMM YYYY")
    };
    this.state = {
      filter: defaultFilter,
      data: null,
      currentPage: 1,
      totalPages: 1,
      per: 50,
      view: props.view,
      activeTab: "confirmed",
      openUserId: null
    };

    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.dateFilterChanged = this.dateFilterChanged.bind(this);
  }

  componentDidMount() {
    this.setState({ loadingInProgress: true }, () => {
      this.fetchItems();
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.view !== prevProps.view) {
      const filter = {
        view: this.props.view,
        completed: "true",
        date_field: "created_at",
        start_date: moment()
          .tz("Australia/Sydney")
          .subtract(1, "day")
          .format("DD MMM YYYY"),
        end_date: moment()
          .tz("Australia/Sydney")
          .subtract(1, "day")
          .format("DD MMM YYYY")
      };
      this.setState({ filter: filter, currentPage: 1 }, this.fetchItems);
    }
  }

  handleFilterChange(event) {
    let filter = { ...this.state.filter };
    filter[event.target.id] = event.target.value;
    this.setState({ filter: filter }, this.fetchItems);
  }

  dateFilterChanged(field, value) {
    let filter = { ...this.state.filter };
    filter[field] = value.format("DD MMM YYYY");
    this.setState({ filter: filter, currentPage: 1 }, this.fetchItems);
  }

  fetchItems() {
    this.setState({ loadingInProgress: true });
    ReportsService.salesPersonResults({
      filter: this.state.filter,
      page: this.state.currentPage,
      per: this.state.per
    }).then(data => {
      this.setState({ loadingInProgress: false, data: data });
    });
  }

  handleSelectTab = tab => {
    this.setState({ activeTab: tab }, () => {});
  };

  handleToggleDiv = userId => {
    this.setState(prevState => ({
      openUserId: prevState.openUserId === userId ? null : userId
    }));
  };

  render() {
    if (!this.state.data) return null;
    const { data } = this.state;
    return (
      <LoadingIndicator loadingInProgress={this.state.loadingInProgress}>
        <div>
          <h4 className="font-bold">
            Yesterday {"("}
            {moment()
              .tz("Australia/Sydney")
              .subtract(1, "day")
              .format("MMM D")}
            {")"}
          </h4>
          <div className="d-flex gap-16">
            <div>
              <h4>Sales Summary</h4>
              {<UserSalesStatsTable users={data.users_last_day} />}
            </div>
            <div>
              <h4>Presentation Summary</h4>
              {<UserPresentedStatsTable users={data.users_last_day} />}
            </div>
          </div>
          <h4 className="font-bold">
            Last 7 days {"("}
            {moment()
              .tz("Australia/Sydney")
              .subtract(7, "day")
              .format("MMM D")}
            -
            {moment()
              .tz("Australia/Sydney")
              .subtract(1, "day")
              .format("MMM D")}
            {")"}
          </h4>
          <div className="d-flex gap-16">
            <div>
              <h4>Sales Summary</h4>
              {<UserSalesStatsTable users={data.users_last_seven_days} />}
            </div>
            <div>
              <h4>Presentation Summary</h4>
              {<UserPresentedStatsTable users={data.users_last_seven_days} />}
            </div>
          </div>
          <h4 className="font-bold">
            Last 14 days {"("}
            {moment()
              .tz("Australia/Sydney")
              .subtract(14, "day")
              .format("MMM D")}
            -
            {moment()
              .tz("Australia/Sydney")
              .subtract(1, "day")
              .format("MMM D")}
            {")"}
          </h4>
          <div className="d-flex gap-16">
            <div>
              <h4>Sales Summary</h4>
              {<UserSalesStatsTable users={data.users_last_fourteen_days} />}
            </div>
            <div>
              <h4>Presentation Summary</h4>
              {<UserPresentedStatsTable users={data.users_last_fourteen_days} />}
            </div>
          </div>
          <h4 className="font-bold">
            Last 30 days {"("}
            {moment()
              .tz("Australia/Sydney")
              .subtract(30, "day")
              .format("MMM D")}
            -
            {moment()
              .tz("Australia/Sydney")
              .subtract(1, "day")
              .format("MMM D")}
            {")"}
          </h4>
          <div className="d-flex gap-16">
            <div>
              <h4>Sales Summary</h4>
              {<UserSalesStatsTable users={data.users_last_thirty_days} />}
            </div>
            <div>
              <h4>Presentation Summary</h4>
              {<UserPresentedStatsTable users={data.users_last_thirty_days} />}
            </div>
          </div>
          <h4 className="font-bold">
            Last 60 days {"("}
            {moment()
              .tz("Australia/Sydney")
              .subtract(60, "day")
              .format("MMM D")}
            -
            {moment()
              .tz("Australia/Sydney")
              .subtract(1, "day")
              .format("MMM D")}
            {")"}
          </h4>
          <div className="d-flex gap-16">
            <div>
              <h4>Sales Summary</h4>
              {<UserSalesStatsTable users={data.users_last_sixty_days} />}
            </div>
            <div>
              <h4>Presentation Summary</h4>
              {<UserPresentedStatsTable users={data.users_last_sixty_days} />}
            </div>
          </div>
          <h3>Choose a range</h3>
          <div>
            <div style={{ display: "inline-block", marginRight: 10 }}>
              <Datetime
                inputProps={{ className: "" }}
                onChange={v => this.dateFilterChanged("start_date", v)}
                value={this.state.filter.start_date}
                closeOnSelect={true}
                dateFormat="DD MMM YYYY"
                timeFormat={false}
              />
            </div>

            <div style={{ display: "inline-block", marginRight: 10 }}>
              <Datetime
                inputProps={{ className: "" }}
                onChange={v => this.dateFilterChanged("end_date", v)}
                value={this.state.filter.end_date}
                closeOnSelect={true}
                dateFormat="DD MMM YYYY"
                timeFormat={false}
              />
            </div>
            <div style={{ display: "inline-block", marginRight: 10 }}>
              <select
                id="date_field"
                value={this.state.filter.date_field}
                onChange={this.handleFilterChange}
              >
                <option value="tcs_at">TCS At</option>
              </select>
            </div>
          </div>
        </div>
        <div>
          <h3>Sales Person Results</h3>
          <div className="row">
            <div className="col-md-6">
              <Stat
                number={data.stats.scheduled}
                text="Scheduled"
                show_number={true}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <div className="clearfix">
                <Stat
                  number={data.stats.confirmed}
                  text="Confirmed"
                  percentage={data.percentages.confirmed_to_scheduled}
                  show_number={true}
                />
              </div>
              <div className="clearfix">
                <Stat
                  number={data.stats.presented}
                  text="Presented"
                  percentage={data.percentages.presented_to_confirmed}
                  show_number={true}
                />
              </div>
              <div className="clearfix">
                <Stat
                  number={data.stats.sales}
                  text="Sales"
                  percentage={data.percentages.sales_to_presented}
                  show_number={true}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="clearfix">
                <Stat
                  number={data.stats.scheduled - data.stats.confirmed}
                  text="Unconfirmed"
                  percentage={data.percentages.unconfirmed_to_scheduled}
                  show_number={true}
                />
              </div>
              <div className="clearfix">
                <Stat
                  number={data.stats.confirmed - data.stats.presented}
                  text="Unpresented"
                  percentage={data.percentages.unpresented_to_confirmed}
                  show_number={true}
                />
              </div>
              <div className="clearfix">
                <Stat
                  number={data.stats.presented - data.stats.sales}
                  text="Unsold"
                  percentage={data.percentages.unsold_to_presented}
                  show_number={true}
                />
              </div>
              <div className="clearfix">
                <Stat
                  number={data.stats.cancelled}
                  text="Cancelled Sale"
                  percentage={data.percentages.cancelled_to_presented}
                  show_number={true}
                  alert={true}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="clearfix">
                <Stat
                  number={data.stats.rescheduled}
                  text="Rescheduled"
                  percentage={data.percentages.rescheduled_to_scheduled}
                  show_number={true}
                />
              </div>
              <div className="clearfix">
                <Stat
                  number={data.stats.presented}
                  text="Presented : Scheduled"
                  percentage={data.percentages.presented_to_scheduled}
                  show_number={false}
                />
              </div>
              <div className="clearfix">
                <Stat
                  number={data.stats.sales}
                  text="Sold : Scheduled"
                  percentage={data.percentages.sales_to_scheduled}
                  show_number={false}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex flex-col">
          <div className="col-sm-6 row">
            <h4>Sales Summary</h4>
            {<UserSalesStatsTable users={data.users} />}
          </div>
          <div className="col-sm-6 row">
            <h4>Presentation Summary</h4>
            {<UserPresentedStatsTable users={data.users} />}
          </div>
        </div>

        {data.users.map(user => (
          <div key={user.id}>
            <h2
              onClick={() => this.handleToggleDiv(user.id)}
              style={{ cursor: "pointer" }}
            >
              {" "}
              &gt; {user.name}
            </h2>
            <div>{user.conversion_rate}% Conversion Rate</div>
            <div>
              {user.sales - (user.cancelled || 0)}/{user.presented} (
              {user.sales} sales, {user.cancelled || 0} cancelled from{" "}
              {user.presented} presentations)
            </div>
            <p>__________________________________________________________</p>
            <div>{user.presentation_rate}% Presentation Rate</div>
            <div>
              {user.presented}/{user.confirmed} ({user.presented} presentations
              from {user.confirmed} confirmed calls)
            </div>
            <br></br>
            {this.state.openUserId === user.id && (
              <div>
                <Nav
                  bsStyle="tabs"
                  activeKey={this.state.activeTab}
                  onSelect={this.handleSelectTab.bind(this)}
                >
                  <NavItem eventKey="confirmed">Confirmed</NavItem>
                  <NavItem eventKey="presented">Presented</NavItem>
                  <NavItem eventKey="unpresented">Unpresented</NavItem>
                  <NavItem eventKey="sales">Sales</NavItem>
                  <NavItem eventKey="unsold">Unsold</NavItem>
                  <NavItem eventKey="rescheduled">Rescheduled</NavItem>
                  <NavItem eventKey="cancelled">Cancelled Sale</NavItem>
                </Nav>
                <div className="tab-content">
                  {this.state.activeTab === "confirmed" && (
                    <DealTable
                      deals={data.deals.filter(
                        d =>
                          d.confirmed_by === user.email &&
                          d.flags.includes("tcs_attendee_confirmed")
                      )}
                      tab={this.state.activeTab}
                    />
                  )}
                  {this.state.activeTab === "presented" && (
                    <DealTable
                      deals={data.deals.filter(
                        d =>
                          d.presented_by === user.email &&
                          d.flags.includes("tcs_attendee_confirmed")
                      )}
                      tab={this.state.activeTab}
                    />
                  )}
                  {this.state.activeTab === "unpresented" && (
                    <DealTable
                      deals={data.deals.filter(
                        d =>
                          d.confirmed_by === user.email &&
                          d.flags.includes("tcs_attendee_confirmed") &&
                          !d.presented_by
                      )}
                      tab={this.state.activeTab}
                    />
                  )}
                  {this.state.activeTab === "sales" && (
                    <DealTable
                      deals={data.deals.filter(
                        d =>
                          d.sale_made_by === user.email &&
                          d.flags.includes("tcs_attendee_confirmed") &&
                          d.flags.includes("sale_made")
                      )}
                      tab={this.state.activeTab}
                    />
                  )}
                  {this.state.activeTab === "cancelled" && (
                    <DealTable
                      deals={data.deals.filter(
                        d =>
                          d.cancelled_by === user.email &&
                          d.flags.includes("tcs_cancelled")
                      )}
                      tab={this.state.activeTab}
                    />
                  )}
                  {this.state.activeTab === "unsold" && (
                    <DealTable
                      deals={data.deals.filter(
                        d =>
                          d.presented_by === user.email &&
                          d.flags.includes("tcs_attendee_confirmed") &&
                          !d.flags.includes("sale_made")
                      )}
                      tab={this.state.activeTab}
                    />
                  )}
                  {this.state.activeTab === "rescheduled" && (
                    <DealTable
                      deals={data.deals.filter(
                        d =>
                          d.tcs_assigned_to === user.email &&
                          d.flags.includes("tcs_rescheduled")
                      )}
                      tab={this.state.activeTab}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        ))}

        <h4>Matching Deals</h4>
        <Nav
          bsStyle="tabs"
          activeKey={this.state.activeTab}
          onSelect={this.handleSelectTab.bind(this)}
        >
          <NavItem eventKey="scheduled">Scheduled</NavItem>
          <NavItem eventKey="confirmed">Confirmed</NavItem>
          <NavItem eventKey="unconfirmed">Unconfirmed</NavItem>
          <NavItem eventKey="presented">Presented</NavItem>
          <NavItem eventKey="unpresented">Unpresented</NavItem>
          <NavItem eventKey="sales">Sales</NavItem>
          <NavItem eventKey="unsold">Unsold</NavItem>
          <NavItem eventKey="rescheduled">Rescheduled</NavItem>
          <NavItem eventKey="cancelled">Cancelled Sale</NavItem>
        </Nav>
        <div className="tab-content">
          {this.state.activeTab === "scheduled" && (
            <DealTable deals={data.deals} tab={this.state.activeTab} />
          )}
          {this.state.activeTab === "confirmed" && (
            <DealTable
              deals={data.deals.filter(d =>
                d.flags.includes("tcs_attendee_confirmed")
              )}
              tab={this.state.activeTab}
            />
          )}
          {this.state.activeTab === "unconfirmed" && (
            <DealTable
              deals={data.deals.filter(
                d => !d.flags.includes("tcs_attendee_confirmed")
              )}
              tab={this.state.activeTab}
            />
          )}
          {this.state.activeTab === "presented" && (
            <DealTable
              deals={data.deals.filter(
                d =>
                  d.flags.includes("tcs_attendee_confirmed") &&
                  d.presented_by
              )}
              tab={this.state.activeTab}
            />
          )}
          {this.state.activeTab === "unpresented" && (
            <DealTable
              deals={data.deals.filter(
                d =>
                  d.flags.includes("tcs_attendee_confirmed") &&
                  !d.presented_by
              )}
              tab={this.state.activeTab}
            />
          )}
          {this.state.activeTab === "sales" && (
            <DealTable
              deals={data.deals.filter(
                d =>
                  d.flags.includes("tcs_attendee_confirmed") &&
                  d.sale_made_by &&
                  d.flags.includes("sale_made")
              )}
              tab={this.state.activeTab}
            />
          )}
          {this.state.activeTab === "cancelled" && (
            <DealTable
              deals={data.deals.filter(d => d.flags.includes("tcs_cancelled"))}
              tab={this.state.activeTab}
            />
          )}
          {this.state.activeTab === "unsold" && (
            <DealTable
              deals={data.deals.filter(
                d =>
                  d.flags.includes("tcs_attendee_confirmed") &&
                  d.presented_by &&
                  !d.flags.includes("sale_made")
              )}
              tab={this.state.activeTab}
            />
          )}
          {this.state.activeTab === "rescheduled" && (
            <DealTable
              deals={data.deals.filter(d =>
                d.flags.includes("tcs_rescheduled")
              )}
              tab={this.state.activeTab}
            />
          )}
        </div>
      </LoadingIndicator>
    );
  }
}
export default ReportingSalesPersonResults;
